import React from 'react'
import { Button, Modal, Tree, Spin, message } from 'antd';
import { useState, useEffect } from 'react';
import { User_Pipeline, User_Pipeline_Set } from "@/services/inspection_pilots"; // 引入Ajax
import local from '@/utils/local'

const Jurisdiction = (record) => {
  const { JurisdictionVal, visible, Operation } = record
  const [spinningLoading, _spinningLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const [treeData, settreeData] = useState([]); //树
  const [checkedKeys, setCheckedKeys] = useState([]); //选中复选框的树节点
  const [checkParentKeys, setCheckParentKeys] = useState([]);//

  useEffect(() => {
    if (visible) {
      onUser_Pipeline()
    }
  }, [visible]);// eslint-disable-line react-hooks/exhaustive-deps

  // 获取用户分配管线权限
  const onUser_Pipeline = async () => {
    _spinningLoading(true)
    const res = await User_Pipeline({
      access_token: local.get('cruise_m350_token') || '',
      userId: JurisdictionVal.id,
    })
    _spinningLoading(false)
    if (res.ret == 200) { // eslint-disable-line
      settreeData(res.data.treeData || [])
      setCheckedKeys(res.data.checkedKeys || '');
    }
  };
  // 设置用户管线权限
  const onUser_Pipeline_Set = async () => {
    _spinningLoading(true)
    setloading(true)

    let arr = [];
    for (let i = 0; i < checkParentKeys.length; i++) {
      if (checkedKeys?.indexOf(checkParentKeys[i]) < 0) {
        arr.push(checkParentKeys[i]);
      }
    }
    arr = [...arr, ...checkedKeys];
    const res = await User_Pipeline_Set({
      access_token: local.get('cruise_m350_token') || '',
      userId: JurisdictionVal.id,
      pipeIds: arr,
    })
    _spinningLoading(false)
    setloading(false)
    if (res.ret == 200) { // eslint-disable-line
      message.success(res.msg || '操作成功', 1.5);
      Operation(false)
    }
  };

  const onCheck = (checkedKeysValue, info) => {
    setCheckParentKeys(info.halfCheckedKeys);
    setCheckedKeys(checkedKeysValue);
  };

  const handleOk = (e) => {
    onUser_Pipeline_Set()
  };
  const handleCancel = (e) => {
    Operation(false)
  };

  return (
    <>
      <Modal
        title="权限修改"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
            确定
          </Button>,
        ]}
      >
        <Spin spinning={spinningLoading}>
          <Tree
            checkable
            onCheck={onCheck}
            checkedKeys={checkedKeys}
            treeData={treeData}
          />
        </Spin>

      </Modal>
    </>
  );
}

export default React.memo(Jurisdiction)